import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Loader from '../../../../core/components/KnowledgeBase';
import KnowledgeBaseView from '../KnowledgeBaseView';
const KnowledgeBaseRoutes = (props) => {
  const { path } = props.match;
  return (
    <div>
      <Switch>
        <Route
          path={`${path}`}
          exact
          render={() => (
            <Loader {...props}>
              <KnowledgeBaseView />
            </Loader>
          )}
        />
      </Switch>
    </div>
  );
};

export default KnowledgeBaseRoutes;
